import React from 'react';
import Dialog from '../adapters/Dialog'
import Button from '../adapters/Button';

import {useDispatch} from "react-redux";
//import {toggleModal} from '../../redux/application';

import GetSignParams from './GetSignParams';
import {register} from '../../redux/user';
import Grid from "@material-ui/core/Grid";
import TextField from '../adapters/TextField';
import {Form} from "react-final-form";
import {makeStyles} from "@material-ui/core/styles";
import {validateEmail} from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: theme.spacing(3),
    }
  })
);

export default function Register({open, toggle}) {

  const dispatch = useDispatch();

  let submit;

  async function submitRegister(values) {
    if (await dispatch(register(values))) {
      toggle(false);
    }
  }

  function validate(values) {
    let errors = {};
    if (!values.login)
      errors.login = 'Необхідно заповнити поле "Логін (адреса електронної пошти)"';
    if (values.login && validateEmail(values.login))
      errors.login = 'Введено некоректну адресу електронної пошти';
    if (!values.password)
      errors.password = 'Необхідно заповнити поле "Пароль"';
    if (values.password && values.password.length < 6)
      errors.password = 'Довжина паролю має бути не менше 6 символів';
    if (values.password && values.password != values.passwordRepeat)
      errors.passwordRepeat = 'Введені паролі не співпадають';
    return errors;
  }

  const classes = useStyles();

  const credits =
    <Form
      onSubmit={submitRegister}
      validate={validate}
      render={({handleSubmit}) => {
        submit = handleSubmit;
        return (
          <form className={classes.form} onSubmit={handleSubmit} noValidate>
            <Grid container style={{paddingTop: 0}}>
              <Grid item xs={1}/>
              <Grid item xs={10}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <TextField name="login" label="Логін (адреса електронної пошти)" required/>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField name="password" label="Пароль" type="password" required/>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField name="passwordRepeat" label="Підтвердження паролю" type="password" required/>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={1}/>
            </Grid>
          </form>
        )
      }}
    />

  const sign =
    <GetSignParams/>

  const content = <div>
    {credits}
    {sign}
  </div>

  const actions = <React.Fragment>
    <Button onClick={() => submit()}>Зареєструватись </Button>
    <Button onClick={() => toggle(false)}> Відмінити </Button>
  </React.Fragment>;

  return (
    <Dialog
      open={open}
      title="Реєстрація"
      content={content}
      actions={actions}
    />)

}